module.exports = __webpack_public_path__ + "icon-1.svg?b3e6c550db0e19dcfe0ab14915366960";